module.exports = __webpack_public_path__ + "static/media/ic_why_loan1.966db8ea.svg";